import { BarnApiError, getDownloadUrl } from '../services/barnApi';

/**
 * Opens an empty tab to receive a barn file later.
 *
 * Call it synchronously inside the click handler, before any await: only then does the popup
 * blocker treat it as a user action. `noopener` is not passed because with it `window.open`
 * returns `null` and the tab could never be navigated; `opener` is cleared instead, which gives
 * the same isolation.
 */
export const openBlankTab = (): Window | null => {
    const tab = window.open('', '_blank');
    if (tab) tab.opener = null;
    return tab;
};

/**
 * Sends a barn file to `tab` (opened by `openBlankTab` in the click) or, without a tab, to the
 * current one. Closes the tab and throws with the barn message when the URL cannot be issued.
 */
export const openBarnFile = async (
    fileId: string,
    disposition: 'inline' | 'attachment' = 'inline',
    tab: Window | null = openBlankTab(),
): Promise<void> => {
    try {
        const { downloadUrl } = await getDownloadUrl(fileId, disposition);
        if (tab) {
            tab.location.href = downloadUrl;
            return;
        }
        window.location.href = downloadUrl;
    } catch (error) {
        tab?.close();
        throw new Error(error instanceof BarnApiError ? error.message : 'Erro ao abrir o arquivo');
    }
};
